import { IEvent } from "@lib/store/src/calendar";
import { validateBACnetValue } from "../modal.helpers";
import { EBACnetDataTypes } from "../modal.types";
import i18next from "i18next";

/**
 * Валидация формы на простые ошибки и по типу значений
 * @returns {string} - Текст ошибки
 */
export const getFormError = (
  eventsState: IEvent[],
  selectedWeekDays: number[]
) => {
  if (selectedWeekDays.length === 0) {
    return i18next.t($ => $.scheduleBacnet.errorNoDaysSelected);
  }

  if (eventsState.length === 0) {
    return i18next.t($ => $.scheduleBacnet.errorNoEventsAdded);
  }

  for (const week of eventsState) {
    if (!week.time.hours || !week.time.minutes) {
      return i18next.t($ => $.scheduleBacnet.errorNoTimeSelected);
    }
    if (week.dataType === null) {
      return i18next.t($ => $.scheduleBacnet.errorNoDataTypeSelected);
    }
    if (week.value === null && week.dataType !== EBACnetDataTypes.NULL) {
      return i18next.t($ => $.scheduleBacnet.errorNoValueSelected);
    }

    if (validateBACnetValue(week.value, week.dataType)) {
      return (
        validateBACnetValue(week.value, week.dataType) ||
        i18next.t($ => $.scheduleBacnet.errorValuesDoNotMatchType)
      );
    }
  }

  return "";
};

export { validateBACnetValue };
